/* Model */
class DelayTypeModel extends App.Models.BaseModel {
    modelUrl = 'DelayType';
}

App.Models.DelayType = DelayTypeModel;

/* Collection */
class DelayTypeCollection extends App.Collections.BaseCollection {
    url = 'DelayType';
    model = App.Models.DelayType;
}

App.Collections.DelayTypes = DelayTypeCollection;

/* Router */
class DelayTypeRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'DelayType';
        const model = App.Models.DelayType;
        const collectionClass = App.Collections.DelayTypes;

        super(entityName, model, collectionClass);
    }
}

App.Routers.DelayType = DelayTypeRouter;
